import styled from '@emotion/styled'
import Link from 'next/link'

import { useUser } from '../../hooks'
import { goodURL } from '../../lib/strings'

import HeroImage from '../HeroImage'
import ListHeaderCredit from './ListHeaderCredit'

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: -0.08rem;
  margin-bottom: 0rem;

  ${({ theme }) => theme.media.lUp} {
    font-size: 1.5rem;
  }
`

const Description = styled.div`
  border-width: 0;
  border-left: ${({ theme }) => theme.space[0]} solid
    ${({ theme }) => theme.colors.blue};
  border-image-slice: 1;
  border-image-source: linear-gradient(
    to bottom,
    ${({ theme }) => theme.colors.blue},
    ${({ theme }) => theme.colors.pink}
  );
  font-size: 1.2rem;
  font-weight: 100;
  line-height: 1.3;
  padding-left: ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[3]};
  margin-top: ${({ theme }) => theme.space[3]};
`

const Body = styled.div`
  margin-bottom: ${({ theme }) => theme.space[3]};

  p:first-of-type {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`

function listLink(list) {
  if (list.User) {
    return `/user/${list.User.username.toLowerCase()}`
  } else if (list.url) {
    return goodURL(list.url)
  } else {
    return null
  }
}

function listName(list) {
  return list.User && list.User.username ? list.User.username : list.name
}

const ListHeader = ({ className, list }) => {
  const [user] = useUser()

  return (
    <div className={className}>
      {list.hero_image && <HeroImage src={list.hero_image} />}

      <Title>{list.title}</Title>

      <ListHeaderCredit link={listLink(list)} name={listName(list)} />

      {user && user.id === list.user_id && (
        <Link href={`/list/${list.slug}/edit/${list.token}`}>
          <a
            className="mt3 mb4 db no-underline underline-hover"
            href={`/list/${list.slug}/edit/${list.token}`}
          >
            &#9998; Edit this list
          </a>
        </Link>
      )}

      {list.description && <Description>{list.description}</Description>}

      {list.body && (
        <Body
          dangerouslySetInnerHTML={{
            __html: list.body,
          }}
        />
      )}
    </div>
  )
}

export default ListHeader
